module.exports = __webpack_public_path__ + "static/img/courier.9dcb32c0.svg";